import axios from "axios";
import * as types from '../constants/ActionTypes'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Url's
// const getInfocusItemsUrl = `${process.env.REACT_APP_API_URL}api/csa-app/get-infocus-page-list`;
// const getFAQItemsUrl = `${process.env.REACT_APP_API_URL}mobileshop/get-static-footer-content`;

const getInfocusItemsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-infocus-page-list`;
const getFAQItemsUrl = `${process.env.REACT_APP_API_URL}mobileshop/get-static-footer-content`;


// Actions
const infocusItemsSuccess = data => ({
  type: types.INFOCUSEITEMS_SUCCESS,
  data
});

const infocusItemsRequested = () => ({
  type: types.INFOCUSEITEMS_REQUEST
});

const infocusItemsFailure = error => ({
  type: types.INFOCUSEITEMS_FAILURE,
  error
});

const faqItemsSuccess = data => ({
  type: types.FAQ_ITEMS_SUCCESS,
  data
});

const faqItemsRequested = () => ({
  type: types.FAQ_ITEMS_REQUEST
});

const faqItemsFailure = error => ({
  type: types.FAQ_ITEMS_FAILURE,
  error
});
const aboutUsSuccess = data => ({
  type: types.ABOUT_US_SUCCESS,
  data
});

const aboutUsRequested = () => ({
  type: types.ABOUT_US_REQUEST
});

const aboutUsFailure = error => ({
  type: types.ABOUT_US_FAILURE,
  error
});

const darkThemeColorRquest = () => ({
  type : types.THEMECOLOR_DARK
})

const lightThemeColorRquest = () => ({
  type : types.THEMECOLOR_LIGHT
})


// API
export const getInfocusItems = (connection_id,tenant_name) => {
  return dispatch => {
    dispatch(infocusItemsRequested());
    axios.get(getInfocusItemsUrl, {
      params: {
        connection_id,
        tenant_name:tenant_name
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(infocusItemsSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(infocusItemsFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getFAQItems = (connection_id) => {
  return dispatch => {
    dispatch(faqItemsRequested());
    axios.get(getFAQItemsUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(faqItemsSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(faqItemsFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getAboutUs = (connection_id) => {
  return dispatch => {
    dispatch(aboutUsRequested());
    axios.get(getFAQItemsUrl, {
      params: {
        connection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(aboutUsSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(aboutUsFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const getThemeColor = (data) => {
  return dispatch => {
    if(data === 'Dark'){
      dispatch(darkThemeColorRquest());
    }
    else{
      dispatch(lightThemeColorRquest());
      }
  }
}

